import { gbp, fmtDate, fmtDateTime } from "@/lib/format";
import { StatusBadge } from "@/components/Common";

export function QuoteView({ q }) {
  return (
    <div className="space-y-5" data-testid="quote-view">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Quotation</p>
          <p className="font-heading text-xl font-semibold" data-testid="quote-reference">{q.reference}</p>
          <p className="text-sm text-muted-foreground">For request {q.request_reference}</p>
        </div>
        <StatusBadge status={q.status} testId="quote-status" />
      </div>
      <p className="whitespace-pre-wrap text-sm">{q.description}</p>
      <div className="overflow-x-auto rounded-md border border-border">
        <table className="w-full text-sm">
          <thead className="bg-muted text-left text-xs uppercase tracking-wider text-muted-foreground">
            <tr><th className="p-3">Item</th><th className="p-3 text-right">Qty</th><th className="p-3 text-right">Unit price</th><th className="p-3 text-right">Total</th></tr>
          </thead>
          <tbody>
            {q.items.map((it, i) => (
              <tr key={i} className="border-t border-border" data-testid={`quote-line-${i}`}>
                <td className="p-3">{it.description}</td><td className="p-3 text-right">{it.quantity}</td>
                <td className="p-3 text-right">{gbp(it.unit_price)}</td><td className="p-3 text-right">{gbp(it.line_total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <dl className="ml-auto w-full max-w-xs space-y-1 text-sm">
        <div className="flex justify-between"><dt>Subtotal</dt><dd>{gbp(q.subtotal)}</dd></div>
        {Number(q.discount) > 0 && <div className="flex justify-between"><dt>Discount</dt><dd>−{gbp(q.discount)}</dd></div>}
        {q.vat_applied ? (
          <div className="flex justify-between"><dt>VAT ({Number(q.vat_rate)}%)</dt><dd>{gbp(q.vat_amount)}</dd></div>
        ) : (
          <p className="text-xs text-muted-foreground">VAT not charged.</p>
        )}
        <div className="flex justify-between border-t border-border pt-2 text-base font-semibold"><dt>Total</dt><dd data-testid="quote-total">{gbp(q.total)}</dd></div>
        {q.vat_number && <p className="text-xs text-muted-foreground">VAT no. {q.vat_number}</p>}
      </dl>
      <div className="grid gap-3 text-sm sm:grid-cols-2">
        <p><span className="text-muted-foreground">Issue date:</span> {fmtDate(q.issue_date)}</p>
        <p><span className="text-muted-foreground">Valid until:</span> {fmtDate(q.expiry_date)}</p>
        {q.decision_at && <p data-testid="quote-decision"><span className="text-muted-foreground">{q.status} by {q.decision_by}:</span> {fmtDateTime(q.decision_at)}</p>}
      </div>
      {q.notes && <div><p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Notes</p><p className="whitespace-pre-wrap text-sm">{q.notes}</p></div>}
      {q.terms && <div><p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Terms and conditions</p><p className="whitespace-pre-wrap text-sm text-muted-foreground">{q.terms}</p></div>}
    </div>
  );
}
